import type {
  GetCartByPartnerIdQuery,
  GetDeliveryTimeQuery,
  GetEligibleFinancingQuery,
  GetScoreSolfacilPlusQuery,
  SearchKitBySkuAndRegionQuery,
  SearchKitQuery,
  UserInfoQuery,
} from '~/types/ecommerce/generated.codegen';

export const UserGqlMock = (): UserInfoQuery => ({
  getUser: {
    __typename: 'User',
    email: 'vivianeggentil@gmail.com',
    fullName: 'Testes QA Nao mexer',
    id: 74393,
    profile: 'gerente',
    partner: {
      acceptedCurrentOperatingAgreement: true,
      address: {
        city: 'São Paulo',
        complement: 'apto 42',
        district: 'Consolação',
        number: '164',
        state: 'SP',
        street: 'Rua Bela Cintra',
        zipcode: '01415000',
      },
      id: 90891,
      recipient: {
        email: 'vivianeggentil@gmail.com',
        name: 'Testes QA Não mexer',
        phone: '+55 (11) 10009-1009',
      },
      tradingName: 'Olavo Rocha MEI',
      corporateName: 'Olavo Rocha MEI',
      state_registration: '1234567890',
      wholesale: {
        status: true,
        value: 1000,
      },
    },
  },
});

export const ScoreGqlMock = (): GetScoreSolfacilPlusQuery => ({
  getScoreSolfacilPlus: {
    level: '0',
    current_score: '0',
    go_score: '0',
    next_transition_date: '',
    has_risk: false,
    __typename: 'Score',
  },
});

export const KitsGqlMock = (): SearchKitQuery => ({
  searchKit: {
    meta: {
      count: 132,
      page: 1,
      size: 12,
      __typename: 'Meta',
    },
    facets: [
      {
        filter_name: 'inverters_power',
        title: 'Potência nominal do inversor',
        options: [
          {
            count: 21,
            from: '*',
            to: '*',
            value: '3.0kW',
            __typename: 'FacetOptionOut',
          },
          {
            count: 17,
            from: '*',
            to: '*',
            value: '3.5kW',
            __typename: 'FacetOptionOut',
          },
          {
            count: 15,
            from: '*',
            to: '*',
            value: '3.6kW',
            __typename: 'FacetOptionOut',
          },
          {
            count: 6,
            from: '*',
            to: '*',
            value: '4.0kW',
            __typename: 'FacetOptionOut',
          },
          {
            count: 14,
            from: '*',
            to: '*',
            value: '5.0kW',
            __typename: 'FacetOptionOut',
          },
          {
            count: 11,
            from: '*',
            to: '*',
            value: '6.0kW',
            __typename: 'FacetOptionOut',
          },
          {
            count: 12,
            from: '*',
            to: '*',
            value: '8.0kW',
            __typename: 'FacetOptionOut',
          },
          {
            count: 26,
            from: '*',
            to: '*',
            value: '8.52kW',
            __typename: 'FacetOptionOut',
          },
          {
            count: 4,
            from: '*',
            to: '*',
            value: '10.0kW',
            __typename: 'FacetOptionOut',
          },
          {
            count: 2,
            from: '*',
            to: '*',
            value: '15.0kW',
            __typename: 'FacetOptionOut',
          },
        ],
        __typename: 'FacetOut',
      },
      {
        filter_name: 'structure_installation',
        title: 'Estrutura',
        options: [
          {
            count: 121,
            from: '*',
            to: '*',
            value: 'Cerâmico ou Colonial',
            __typename: 'FacetOptionOut',
          },
          {
            count: 11,
            from: '*',
            to: '*',
            value: 'Trapezoidal',
            __typename: 'FacetOptionOut',
          },
        ],
        __typename: 'FacetOut',
      },
      {
        filter_name: 'inverters_brand',
        title: 'Marca do inversor',
        options: [
          {
            count: 40,
            from: '*',
            to: '*',
            value: 'DEYE',
            __typename: 'FacetOptionOut',
          },
          {
            count: 83,
            from: '*',
            to: '*',
            value: 'GOODWE',
            __typename: 'FacetOptionOut',
          },
          {
            count: 5,
            from: '*',
            to: '*',
            value: 'GROWATT',
            __typename: 'FacetOptionOut',
          },
          {
            count: 4,
            from: '*',
            to: '*',
            value: 'SOLIS',
            __typename: 'FacetOptionOut',
          },
        ],
        __typename: 'FacetOut',
      },
      {
        filter_name: 'modules_brand',
        title: 'Marca do módulo',
        options: [
          {
            count: 132,
            from: '*',
            to: '*',
            value: 'ASTROENERGY',
            __typename: 'FacetOptionOut',
          },
        ],
        __typename: 'FacetOut',
      },
      {
        filter_name: 'modules_power',
        title: 'Potência do módulo',
        options: [
          {
            count: 132,
            from: '*',
            to: '*',
            value: '585W',
            __typename: 'FacetOptionOut',
          },
        ],
        __typename: 'FacetOut',
      },
      {
        filter_name: 'inverters_electric_connection',
        title: 'Tipo de rede',
        options: [
          {
            count: 124,
            from: '*',
            to: '*',
            value: 'Monofásico',
            __typename: 'FacetOptionOut',
          },
          {
            count: 8,
            from: '*',
            to: '*',
            value: 'Trifásico 380V',
            __typename: 'FacetOptionOut',
          },
        ],
        __typename: 'FacetOut',
      },
      {
        filter_name: 'string_box',
        title: 'Stringbox',
        options: [
          {
            count: 23,
            from: '*',
            to: '*',
            value: 'Com Stringbox',
            __typename: 'FacetOptionOut',
          },
          {
            count: 109,
            from: '*',
            to: '*',
            value: 'Sem Stringbox',
            __typename: 'FacetOptionOut',
          },
        ],
        __typename: 'FacetOut',
      },
    ],
    data: [
      {
        code: 1583748,
        dc_id: 2,
        description:
          'Kit Energia Solar 2.92 kWp com 1x Inversor GOODWE 3.0kW MONO - Cerâmico ou Colonial - Módulo ASTROENERGY 5x 585Wp',
        discount_rate: null,
        images: [
          {
            main: true,
            url: 'https://ecommerce-stg-app-store-catalog-ingester-origin.s3.amazonaws.com/contents/kits/771/images/image.jpg',
            __typename: 'ImageModel',
          },
        ],
        marketable: true,
        power: 2.92,
        modules: [
          {
            sku: '559365',
            model: 'HN18N-72H',
            efficiency: 22.65,
            datasheet:
              'https://teste-api.solarinove.com.br/public/files/products/datasheets/88429ba7769b_datasheet.pdf',
            brand: 'ASTROENERGY',
            amount: 5,
            __typename: 'Module',
          },
        ],
        inverters: [
          {
            sku: '600114',
            power: 3,
            model: 'GW 3000-XS-11',
            electric_connection: 'Monofásico',
            datasheet:
              'https://teste-api.solarinove.com.br/public/files/products/datasheets/a9bc778cc21c_datasheet.pdf',
            brand: 'GOODWE',
            amount: 1,
            __typename: 'Inverter',
          },
        ],
        structure: {
          installation: 'Cerâmico ou Colonial',
          datasheet: null,
          __typename: 'Structure',
        },
        price: 5330.91,
        price_from: 5582.1,
        price_raw: 5582.1,
        region: 'SP',
        sku: 'GW3000XS11MONOSH585CER5',
        solfacil_plus: {
          discount_rate: 0.07,
          level: 99,
          __typename: 'SolfacilPlus',
        },
        __typename: 'KitModel',
      },
      {
        code: 1580208,
        dc_id: 2,
        description:
          'Kit Energia Solar 2.92 kWp com 1x Inversor DEYE 3.0kW MONO - Cerâmico ou Colonial - Módulo ASTROENERGY 5x 585Wp',
        discount_rate: null,
        images: [
          {
            main: true,
            url: 'https://ecommerce-stg-app-store-catalog-ingester-origin.s3.amazonaws.com/contents/kits/771/images/image.jpg',
            __typename: 'ImageModel',
          },
        ],
        marketable: true,
        power: 2.92,
        modules: [
          {
            sku: '559365',
            model: 'HN18N-72H',
            efficiency: 22.65,
            datasheet:
              'https://teste-api.solarinove.com.br/public/files/products/datasheets/88429ba7769b_datasheet.pdf',
            brand: 'ASTROENERGY',
            amount: 5,
            __typename: 'Module',
          },
        ],
        inverters: [
          {
            sku: '600074',
            power: 3,
            model: 'SUN-3K-G',
            electric_connection: 'Monofásico',
            datasheet:
              'https://ecommerce-stg-app-store-catalog-ingester-origin.s3.amazonaws.com/contents/products/600074/datasheets/datasheet.pdf',
            brand: 'DEYE',
            amount: 1,
            __typename: 'Inverter',
          },
        ],
        structure: {
          installation: 'Cerâmico ou Colonial',
          datasheet: null,
          __typename: 'Structure',
        },
        price: 5331.86,
        price_from: 5583.1,
        price_raw: 5583.1,
        region: 'SP',
        sku: 'DE3KGMONOSH585CER5',
        solfacil_plus: {
          discount_rate: 0.07,
          level: 99,
          __typename: 'SolfacilPlus',
        },
        __typename: 'KitModel',
      },
      {
        code: 1583116,
        dc_id: 2,
        description:
          'Kit Energia Solar 3.51 kWp com 1x Inversor GOODWE 3.0kW MONO - Cerâmico ou Colonial - Módulo ASTROENERGY 6x 585Wp',
        discount_rate: null,
        images: [
          {
            main: true,
            url: 'https://ecommerce-stg-app-store-catalog-ingester-origin.s3.amazonaws.com/contents/kits/771/images/image.jpg',
            __typename: 'ImageModel',
          },
        ],
        marketable: true,
        power: 3.51,
        modules: [
          {
            sku: '559365',
            model: 'HN18N-72H',
            efficiency: 22.65,
            datasheet:
              'https://teste-api.solarinove.com.br/public/files/products/datasheets/88429ba7769b_datasheet.pdf',
            brand: 'ASTROENERGY',
            amount: 6,
            __typename: 'Module',
          },
        ],
        inverters: [
          {
            sku: '600114',
            power: 3,
            model: 'GW 3000-XS-11',
            electric_connection: 'Monofásico',
            datasheet:
              'https://teste-api.solarinove.com.br/public/files/products/datasheets/a9bc778cc21c_datasheet.pdf',
            brand: 'GOODWE',
            amount: 1,
            __typename: 'Inverter',
          },
        ],
        structure: {
          installation: 'Cerâmico ou Colonial',
          datasheet: null,
          __typename: 'Structure',
        },
        price: 5861.67,
        price_from: 6137.87,
        price_raw: 6137.87,
        region: 'SP',
        sku: 'GW3000XS11MONOSH585CER6',
        solfacil_plus: {
          discount_rate: 0.07,
          level: 99,
          __typename: 'SolfacilPlus',
        },
        __typename: 'KitModel',
      },
      {
        code: 1583158,
        dc_id: 2,
        description:
          'Kit Energia Solar 3.51 kWp com 1x Inversor DEYE 3.0kW MONO - Cerâmico ou Colonial - Módulo ASTROENERGY 6x 585Wp',
        discount_rate: null,
        images: [
          {
            main: true,
            url: 'https://ecommerce-stg-app-store-catalog-ingester-origin.s3.amazonaws.com/contents/kits/771/images/image.jpg',
            __typename: 'ImageModel',
          },
        ],
        marketable: true,
        power: 3.51,
        modules: [
          {
            sku: '559365',
            model: 'HN18N-72H',
            efficiency: 22.65,
            datasheet:
              'https://teste-api.solarinove.com.br/public/files/products/datasheets/88429ba7769b_datasheet.pdf',
            brand: 'ASTROENERGY',
            amount: 6,
            __typename: 'Module',
          },
        ],
        inverters: [
          {
            sku: '600074',
            power: 3,
            model: 'SUN-3K-G',
            electric_connection: 'Monofásico',
            datasheet:
              'https://ecommerce-stg-app-store-catalog-ingester-origin.s3.amazonaws.com/contents/products/600074/datasheets/datasheet.pdf',
            brand: 'DEYE',
            amount: 1,
            __typename: 'Inverter',
          },
        ],
        structure: {
          installation: 'Cerâmico ou Colonial',
          datasheet: null,
          __typename: 'Structure',
        },
        price: 5862.62,
        price_from: 6138.87,
        price_raw: 6138.87,
        region: 'SP',
        sku: 'DE3KGMONOSH585CER6',
        solfacil_plus: {
          discount_rate: 0.07,
          level: 99,
          __typename: 'SolfacilPlus',
        },
        __typename: 'KitModel',
      },
      {
        code: 1580098,
        dc_id: 2,
        description:
          'Kit Energia Solar 3.51 kWp com 1x Inversor DEYE 4.0kW MONO - Cerâmico ou Colonial - Módulo ASTROENERGY 6x 585Wp',
        discount_rate: null,
        images: [
          {
            main: true,
            url: 'https://ecommerce-stg-app-store-catalog-ingester-origin.s3.amazonaws.com/contents/kits/771/images/image.jpg',
            __typename: 'ImageModel',
          },
        ],
        marketable: true,
        power: 3.51,
        modules: [
          {
            sku: '559365',
            model: 'HN18N-72H',
            efficiency: 22.65,
            datasheet:
              'https://teste-api.solarinove.com.br/public/files/products/datasheets/88429ba7769b_datasheet.pdf',
            brand: 'ASTROENERGY',
            amount: 6,
            __typename: 'Module',
          },
        ],
        inverters: [
          {
            sku: '600075',
            power: 4,
            model: 'SUN-4K-G',
            electric_connection: 'Monofásico',
            datasheet:
              'https://ecommerce-stg-app-store-catalog-ingester-origin.s3.amazonaws.com/contents/products/600075/datasheets/datasheet.pdf',
            brand: 'DEYE',
            amount: 1,
            __typename: 'Inverter',
          },
        ],
        structure: {
          installation: 'Cerâmico ou Colonial',
          datasheet: null,
          __typename: 'Structure',
        },
        price: 6482.43,
        price_from: 6787.89,
        price_raw: 6787.89,
        region: 'SP',
        sku: 'DE4KGMONOSH585CER6',
        solfacil_plus: {
          discount_rate: 0.07,
          level: 99,
          __typename: 'SolfacilPlus',
        },
        __typename: 'KitModel',
      },
      {
        code: 1583734,
        dc_id: 2,
        description:
          'Kit Energia Solar 4.09 kWp com 1x Inversor GOODWE 3.0kW MONO - Cerâmico ou Colonial - Módulo ASTROENERGY 7x 585Wp',
        discount_rate: null,
        images: [
          {
            main: true,
            url: 'https://ecommerce-stg-app-store-catalog-ingester-origin.s3.amazonaws.com/contents/kits/771/images/image.jpg',
            __typename: 'ImageModel',
          },
        ],
        marketable: true,
        power: 4.09,
        modules: [
          {
            sku: '559365',
            model: 'HN18N-72H',
            efficiency: 22.65,
            datasheet:
              'https://teste-api.solarinove.com.br/public/files/products/datasheets/88429ba7769b_datasheet.pdf',
            brand: 'ASTROENERGY',
            amount: 7,
            __typename: 'Module',
          },
        ],
        inverters: [
          {
            sku: '600114',
            power: 3,
            model: 'GW 3000-XS-11',
            electric_connection: 'Monofásico',
            datasheet:
              'https://teste-api.solarinove.com.br/public/files/products/datasheets/a9bc778cc21c_datasheet.pdf',
            brand: 'GOODWE',
            amount: 1,
            __typename: 'Inverter',
          },
        ],
        structure: {
          installation: 'Cerâmico ou Colonial',
          datasheet: null,
          __typename: 'Structure',
        },
        price: 6608.49,
        price_from: 6919.89,
        price_raw: 6919.89,
        region: 'SP',
        sku: 'GW3000XS11MONOSH585CER7',
        solfacil_plus: {
          discount_rate: 0.07,
          level: 99,
          __typename: 'SolfacilPlus',
        },
        __typename: 'KitModel',
      },
      {
        code: 1583754,
        dc_id: 2,
        description:
          'Kit Energia Solar 4.68 kWp com 1x Inversor GOODWE 3.0kW MONO - Cerâmico ou Colonial - Módulo ASTROENERGY 8x 585Wp',
        discount_rate: null,
        images: [
          {
            main: true,
            url: 'https://ecommerce-stg-app-store-catalog-ingester-origin.s3.amazonaws.com/contents/kits/771/images/image.jpg',
            __typename: 'ImageModel',
          },
        ],
        marketable: true,
        power: 4.68,
        modules: [
          {
            sku: '559365',
            model: 'HN18N-72H',
            efficiency: 22.65,
            datasheet:
              'https://teste-api.solarinove.com.br/public/files/products/datasheets/88429ba7769b_datasheet.pdf',
            brand: 'ASTROENERGY',
            amount: 8,
            __typename: 'Module',
          },
        ],
        inverters: [
          {
            sku: '600114',
            power: 3,
            model: 'GW 3000-XS-11',
            electric_connection: 'Monofásico',
            datasheet:
              'https://teste-api.solarinove.com.br/public/files/products/datasheets/a9bc778cc21c_datasheet.pdf',
            brand: 'GOODWE',
            amount: 1,
            __typename: 'Inverter',
          },
        ],
        structure: {
          installation: 'Cerâmico ou Colonial',
          datasheet: null,
          __typename: 'Structure',
        },
        price: 7139.26,
        price_from: 7475.66,
        price_raw: 7475.66,
        region: 'SP',
        sku: 'GW3000XS11MONOSH585CER8',
        solfacil_plus: {
          discount_rate: 0.07,
          level: 99,
          __typename: 'SolfacilPlus',
        },
        __typename: 'KitModel',
      },
      {
        code: 1580231,
        dc_id: 2,
        description:
          'Kit Energia Solar 4.09 kWp com 1x Inversor DEYE 4.0kW MONO - Cerâmico ou Colonial - Módulo ASTROENERGY 7x 585Wp',
        discount_rate: null,
        images: [
          {
            main: true,
            url: 'https://ecommerce-stg-app-store-catalog-ingester-origin.s3.amazonaws.com/contents/kits/771/images/image.jpg',
            __typename: 'ImageModel',
          },
        ],
        marketable: true,
        power: 4.09,
        modules: [
          {
            sku: '559365',
            model: 'HN18N-72H',
            efficiency: 22.65,
            datasheet:
              'https://teste-api.solarinove.com.br/public/files/products/datasheets/88429ba7769b_datasheet.pdf',
            brand: 'ASTROENERGY',
            amount: 7,
            __typename: 'Module',
          },
        ],
        inverters: [
          {
            sku: '600075',
            power: 4,
            model: 'SUN-4K-G',
            electric_connection: 'Monofásico',
            datasheet:
              'https://ecommerce-stg-app-store-catalog-ingester-origin.s3.amazonaws.com/contents/products/600075/datasheets/datasheet.pdf',
            brand: 'DEYE',
            amount: 1,
            __typename: 'Inverter',
          },
        ],
        structure: {
          installation: 'Cerâmico ou Colonial',
          datasheet: null,
          __typename: 'Structure',
        },
        price: 7229.26,
        price_from: 7569.91,
        price_raw: 7569.91,
        region: 'SP',
        sku: 'DE4KGMONOSH585CER7',
        solfacil_plus: {
          discount_rate: 0.07,
          level: 99,
          __typename: 'SolfacilPlus',
        },
        __typename: 'KitModel',
      },
      {
        code: 1580087,
        dc_id: 2,
        description:
          'Kit Energia Solar 4.68 kWp com 1x Inversor DEYE 4.0kW MONO - Cerâmico ou Colonial - Módulo ASTROENERGY 8x 585Wp',
        discount_rate: null,
        images: [
          {
            main: true,
            url: 'https://ecommerce-stg-app-store-catalog-ingester-origin.s3.amazonaws.com/contents/kits/771/images/image.jpg',
            __typename: 'ImageModel',
          },
        ],
        marketable: true,
        power: 4.68,
        modules: [
          {
            sku: '559365',
            model: 'HN18N-72H',
            efficiency: 22.65,
            datasheet:
              'https://teste-api.solarinove.com.br/public/files/products/datasheets/88429ba7769b_datasheet.pdf',
            brand: 'ASTROENERGY',
            amount: 8,
            __typename: 'Module',
          },
        ],
        inverters: [
          {
            sku: '600075',
            power: 4,
            model: 'SUN-4K-G',
            electric_connection: 'Monofásico',
            datasheet:
              'https://ecommerce-stg-app-store-catalog-ingester-origin.s3.amazonaws.com/contents/products/600075/datasheets/datasheet.pdf',
            brand: 'DEYE',
            amount: 1,
            __typename: 'Inverter',
          },
        ],
        structure: {
          installation: 'Cerâmico ou Colonial',
          datasheet: null,
          __typename: 'Structure',
        },
        price: 7760.02,
        price_from: 8125.68,
        price_raw: 8125.68,
        region: 'SP',
        sku: 'DE4KGMONOSH585CER8',
        solfacil_plus: {
          discount_rate: 0.07,
          level: 99,
          __typename: 'SolfacilPlus',
        },
        __typename: 'KitModel',
      },
      {
        code: 1580099,
        dc_id: 2,
        description:
          'Kit Energia Solar 4.68 kWp com 1x Inversor DEYE 5.0kW MONO - Cerâmico ou Colonial - Módulo ASTROENERGY 8x 585Wp',
        discount_rate: null,
        images: [
          {
            main: true,
            url: 'https://ecommerce-stg-app-store-catalog-ingester-origin.s3.amazonaws.com/contents/kits/771/images/image.jpg',
            __typename: 'ImageModel',
          },
        ],
        marketable: true,
        power: 4.68,
        modules: [
          {
            sku: '559365',
            model: 'HN18N-72H',
            efficiency: 22.65,
            datasheet:
              'https://teste-api.solarinove.com.br/public/files/products/datasheets/88429ba7769b_datasheet.pdf',
            brand: 'ASTROENERGY',
            amount: 8,
            __typename: 'Module',
          },
        ],
        inverters: [
          {
            sku: '600076',
            power: 5,
            model: 'SUN-5K-G',
            electric_connection: 'Monofásico',
            datasheet:
              'https://ecommerce-stg-app-store-catalog-ingester-origin.s3.amazonaws.com/contents/products/600076/datasheets/datasheet.pdf',
            brand: 'DEYE',
            amount: 1,
            __typename: 'Inverter',
          },
        ],
        structure: {
          installation: 'Cerâmico ou Colonial',
          datasheet: null,
          __typename: 'Structure',
        },
        price: 7820.63,
        price_from: 8189.14,
        price_raw: 8189.14,
        region: 'SP',
        sku: 'DE5KGMONOSH585CER8',
        solfacil_plus: {
          discount_rate: 0.07,
          level: 99,
          __typename: 'SolfacilPlus',
        },
        __typename: 'KitModel',
      },
      {
        code: 1583751,
        dc_id: 2,
        description:
          'Kit Energia Solar 5.26 kWp com 1x Inversor GOODWE 3.0kW MONO - Cerâmico ou Colonial - Módulo ASTROENERGY 9x 585Wp',
        discount_rate: null,
        images: [
          {
            main: true,
            url: 'https://ecommerce-stg-app-store-catalog-ingester-origin.s3.amazonaws.com/contents/kits/771/images/image.jpg',
            __typename: 'ImageModel',
          },
        ],
        marketable: true,
        power: 5.26,
        modules: [
          {
            sku: '559365',
            model: 'HN18N-72H',
            efficiency: 22.65,
            datasheet:
              'https://teste-api.solarinove.com.br/public/files/products/datasheets/88429ba7769b_datasheet.pdf',
            brand: 'ASTROENERGY',
            amount: 9,
            __typename: 'Module',
          },
        ],
        inverters: [
          {
            sku: '600114',
            power: 3,
            model: 'GW 3000-XS-11',
            electric_connection: 'Monofásico',
            datasheet:
              'https://teste-api.solarinove.com.br/public/files/products/datasheets/a9bc778cc21c_datasheet.pdf',
            brand: 'GOODWE',
            amount: 1,
            __typename: 'Inverter',
          },
        ],
        structure: {
          installation: 'Cerâmico ou Colonial',
          datasheet: null,
          __typename: 'Structure',
        },
        price: 7886.08,
        price_from: 8257.68,
        price_raw: 8257.68,
        region: 'SP',
        sku: 'GW3000XS11MONOSH585CER9',
        solfacil_plus: {
          discount_rate: 0.07,
          level: 99,
          __typename: 'SolfacilPlus',
        },
        __typename: 'KitModel',
      },
      {
        code: 1580215,
        dc_id: 2,
        description:
          'Kit Energia Solar 5.26 kWp com 1x Inversor DEYE 5.0kW MONO - Cerâmico ou Colonial - Módulo ASTROENERGY 9x 585Wp',
        discount_rate: null,
        images: [
          {
            main: true,
            url: 'https://ecommerce-stg-app-store-catalog-ingester-origin.s3.amazonaws.com/contents/kits/771/images/image.jpg',
            __typename: 'ImageModel',
          },
        ],
        marketable: true,
        power: 5.26,
        modules: [
          {
            sku: '559365',
            model: 'HN18N-72H',
            efficiency: 22.65,
            datasheet:
              'https://teste-api.solarinove.com.br/public/files/products/datasheets/88429ba7769b_datasheet.pdf',
            brand: 'ASTROENERGY',
            amount: 9,
            __typename: 'Module',
          },
        ],
        inverters: [
          {
            sku: '600076',
            power: 5,
            model: 'SUN-5K-G',
            electric_connection: 'Monofásico',
            datasheet:
              'https://ecommerce-stg-app-store-catalog-ingester-origin.s3.amazonaws.com/contents/products/600076/datasheets/datasheet.pdf',
            brand: 'DEYE',
            amount: 1,
            __typename: 'Inverter',
          },
        ],
        structure: {
          installation: 'Cerâmico ou Colonial',
          datasheet: null,
          __typename: 'Structure',
        },
        price: 8567.46,
        price_from: 8971.16,
        price_raw: 8971.16,
        region: 'SP',
        sku: 'DE5KGMONOSH585CER9',
        solfacil_plus: {
          discount_rate: 0.07,
          level: 99,
          __typename: 'SolfacilPlus',
        },
        __typename: 'KitModel',
      },
    ],
    __typename: 'SearchKitOut',
  },
});

export const KitGqlMock = (): SearchKitBySkuAndRegionQuery => ({
  searchKitBySkuAndRegion: {
    code: 1583748,
    datasheets: [
      {
        model: 'GW 3000-XS-11',
        label: 'Datasheet do inversor',
        name: 'inverters',
        value:
          'https://teste-api.solarinove.com.br/public/files/products/datasheets/a9bc778cc21c_datasheet.pdf',
        __typename: 'Datasheet',
      },
      {
        model: 'HN18N-72H',
        label: 'Datasheet do módulo',
        name: 'modules',
        value:
          'https://teste-api.solarinove.com.br/public/files/products/datasheets/88429ba7769b_datasheet.pdf',
        __typename: 'Datasheet',
      },
    ],
    big_numbers: [
      {
        label: 'Potência do Kit',
        name: 'power',
        value: '2.92 kWp',
        __typename: 'BigNumber',
      },
      {
        label: 'Potência do Inversor',
        name: 'power_inverter',
        value: '3 kW',
        __typename: 'BigNumber',
      },
      {
        label: 'Potência do Módulo',
        name: 'power_range',
        value: '585W',
        __typename: 'BigNumber',
      },
      {
        label: 'Eficiência do Módulo',
        name: 'efficiency',
        value: '22.65 %',
        __typename: 'BigNumber',
      },
      {
        label: 'Estrutura',
        name: 'structure',
        value: 'Cerâmico ou Colonial',
        __typename: 'BigNumber',
      },
      {
        label: 'Tipo de Rede',
        name: 'electric_connection',
        value: 'Monofásico',
        __typename: 'BigNumber',
      },
    ],
    images: [
      {
        main: true,
        url: 'https://ecommerce-stg-app-store-catalog-ingester-origin.s3.amazonaws.com/contents/kits/771/images/image.jpg',
        __typename: 'ImageModel',
      },
    ],
    dc_id: 2,
    description:
      'Kit Energia Solar 2.92 kWp com 1x Inversor GOODWE 3.0kW MONO - Cerâmico ou Colonial - Módulo ASTROENERGY 5x 585Wp',
    discount_rate: null,
    marketable: true,
    power: 2.92,
    modules: [
      {
        sku: '559365',
        model: 'HN18N-72H',
        efficiency: 22.65,
        datasheet:
          'https://teste-api.solarinove.com.br/public/files/products/datasheets/88429ba7769b_datasheet.pdf',
        brand: 'ASTROENERGY',
        amount: 5,
        __typename: 'Module',
      },
    ],
    inverters: [
      {
        sku: '600114',
        power: 3,
        model: 'GW 3000-XS-11',
        electric_connection: 'Monofásico',
        datasheet:
          'https://teste-api.solarinove.com.br/public/files/products/datasheets/a9bc778cc21c_datasheet.pdf',
        brand: 'GOODWE',
        amount: 1,
        __typename: 'Inverter',
      },
    ],
    structure: {
      datasheet: null,
      installation: 'Cerâmico ou Colonial',
      __typename: 'Structure',
    },
    pre_sale: true,
    available_at: '2024-08-27',
    price: 5330.91,
    price_from: 5582.1,
    price_raw: 5582.1,
    region: 'SP',
    sku: 'GW3000XS11MONOSH585CER5',
    solfacil_plus: {
      discount_rate: 0.07,
      level: 99,
      __typename: 'SolfacilPlus',
    },
    details: [
      {
        category: 'Inversor',
        descriptions: [
          {
            amount: 1,
            name: 'INVERSOR FOTOVOLTAICO GW 3000-XS-11 3KW GOODWE MONO 220V / Potência Nominal: 3 kW / Modelo: GW 3000-XS-11 / Tipo de rede: Monofásico',
            __typename: 'DetailDescription',
          },
        ],
        id: 1,
        __typename: 'Detail',
      },
      {
        category: 'Módulos',
        descriptions: [
          {
            amount: 5,
            name: 'MODULO FOTOVOLTAICO 585W - HANERSUN (HN18N-72H) / Modelo: HN18N-72H',
            __typename: 'DetailDescription',
          },
        ],
        id: 2,
        __typename: 'Detail',
      },
      {
        category: 'Estrutura',
        descriptions: [
          {
            amount: 6,
            name: 'PERFIL AL TF - 007 - 2400MM P/ SUPORTE SISTEMA FOTOVOLTAICO',
            __typename: 'DetailDescription',
          },
          {
            amount: 3,
            name: 'SUPORTE P/ TELHA CERAMICA NV P/ 2 MODULOS P/ SISTEMA FOTOVOLTAICO (TF-007 - SUPORTE S) - S/ PERFIL',
            __typename: 'DetailDescription',
          },
        ],
        id: 3,
        __typename: 'Detail',
      },
      {
        category: 'Cabos',
        descriptions: [
          {
            amount: 1,
            name: 'CABO SOLAR 4,0MM2 VERMELHO C/25 MT (PROTECAO UV 1,8KVCC)',
            __typename: 'DetailDescription',
          },
          {
            amount: 1,
            name: 'CABO SOLAR 4,0MM2 PRETO C/ 25 MT (PROTECAO UV 1,8KVCC)',
            __typename: 'DetailDescription',
          },
        ],
        id: 5,
        __typename: 'Detail',
      },
      {
        category: 'Itens adicionais',
        descriptions: [
          {
            amount: 2,
            name: 'CONECTOR (PAR) MC4 4MM SOLAR',
            __typename: 'DetailDescription',
          },
        ],
        id: 6,
        __typename: 'Detail',
      },
    ],
    __typename: 'SearchKitBySkuAndRegionOut',
  },
});

export const CartGqlMock = (): GetCartByPartnerIdQuery => ({
  getCartByPartner: {
    id: '7f6899ed-8df3-45c6-a318-8b84fdbc4c12',
    max_value_manual_discount: 'R$ 400,00',
    category: {
      id: 1,
      description: 'kit',
      __typename: 'CategoryOut',
    },
    type: {
      id: 1,
      description: 'order',
      __typename: 'TypeOut',
    },
    dc_id: 2,
    region: 'SP',
    items: [
      {
        amount: 1,
        description:
          'Kit Energia Solar 2.92 kWp com 1x Inversor GOODWE 3.0kW MONO - Cerâmico ou Colonial - Módulo ASTROENERGY 5x 585Wp',
        details: [
          {
            category: 'Inversor',
            descriptions: [
              {
                amount: 1,
                name: 'INVERSOR FOTOVOLTAICO GW 3000-XS-11 3KW GOODWE MONO 220V / Potência Nominal: 3 kW / Modelo: GW 3000-XS-11 / Tipo de rede: Monofásico',
                __typename: 'DetailDescriptionOut',
              },
            ],
            __typename: 'DetailsOut',
          },
          {
            category: 'Módulos',
            descriptions: [
              {
                amount: 5,
                name: 'MODULO FOTOVOLTAICO 585W - HANERSUN (HN18N-72H) / Modelo: HN18N-72H',
                __typename: 'DetailDescriptionOut',
              },
            ],
            __typename: 'DetailsOut',
          },
          {
            category: 'Estrutura',
            descriptions: [
              {
                amount: 6,
                name: 'PERFIL AL TF - 007 - 2400MM P/ SUPORTE SISTEMA FOTOVOLTAICO',
                __typename: 'DetailDescriptionOut',
              },
              {
                amount: 3,
                name: 'SUPORTE P/ TELHA CERAMICA NV P/ 2 MODULOS P/ SISTEMA FOTOVOLTAICO (TF-007 - SUPORTE S) - S/ PERFIL',
                __typename: 'DetailDescriptionOut',
              },
            ],
            __typename: 'DetailsOut',
          },
          {
            category: 'Cabos',
            descriptions: [
              {
                amount: 1,
                name: 'CABO SOLAR 4,0MM2 VERMELHO C/25 MT (PROTECAO UV 1,8KVCC)',
                __typename: 'DetailDescriptionOut',
              },
              {
                amount: 1,
                name: 'CABO SOLAR 4,0MM2 PRETO C/ 25 MT (PROTECAO UV 1,8KVCC)',
                __typename: 'DetailDescriptionOut',
              },
            ],
            __typename: 'DetailsOut',
          },
          {
            category: 'Itens adicionais',
            descriptions: [
              {
                amount: 2,
                name: 'CONECTOR (PAR) MC4 4MM SOLAR',
                __typename: 'DetailDescriptionOut',
              },
            ],
            __typename: 'DetailsOut',
          },
        ],
        images: [
          {
            url: 'https://ecommerce-stg-app-store-catalog-ingester-origin.s3.amazonaws.com/contents/kits/771/images/image.jpg',
            __typename: 'ImageOut',
          },
        ],
        discount_rate: 0,
        price: 5330.91,
        price_raw: 5582.1,
        price_from: 5582.11,
        sku: 'GW3000XS11MONOSH585CER5',
        status: {
          description: 'ok',
          id: 1,
          __typename: 'CartItemStatusOut',
        },
        pre_sale: true,
        available_at: '2024-08-27',
        total: 5330.91,
        subtotal: 5582.11,
        __typename: 'CartItemOut',
      },
    ],
    shipping: null,
    payment: null,
    summary: {
      body: {
        items: [
          {
            title: 'Subtotal',
            type: 'summary_item',
            information: null,
            value: 'R$ 5.582,10',
            __typename: 'SummaryItem',
          },
          {
            title: 'Desconto Solfácil Mais',
            type: 'summary_item',
            information:
              'Você tem 0,5% de desconto por ser Nível 2 no Solfácil Mais.',
            value: '- R$ 27,91',
            __typename: 'SummaryItem',
          },
          {
            title: 'Descontos personalizados',
            type: 'summary_item',
            information: null,
            value: '- R$ 223,28',
            __typename: 'SummaryItem',
          },
          {
            title: 'Desconto por volume',
            type: 'summary_item',
            information:
              'Quanto maior o volume da sua compra, maior o seu desconto.',
            value: 'R$ 0,00',
            __typename: 'SummaryItem',
          },
          {
            title: 'Cupom de desconto',
            type: 'summary_item',
            information: null,
            value: 'R$ 0,00',
            __typename: 'SummaryItem',
          },
          {
            title: 'Seguro',
            type: 'summary_item',
            information: null,
            value: '+ R$ 53,31',
            __typename: 'SummaryItem',
          },
          {
            title: 'Frete',
            type: 'summary_item',
            information: null,
            value: '+ R$ 356,70',
            __typename: 'SummaryItem',
          },
          {
            title: 'Total',
            type: 'summary_final',
            information: null,
            value: 'R$ 5.740,92',
            __typename: 'SummaryItem',
          },
        ],
        __typename: 'SummaryBody',
      },
      __typename: 'Summary',
    },
    status: {
      description: 'waiting_shipping',
      id: 1,
      __typename: 'StatusOut',
    },
    pre_sale: true,
    available_at: '2024-08-27',
    subtotal: 5582.1,
    total: 5740.92,
    has_insurance: true,
    insurance_value: 53.31,
    partner: {
      id: 90891,
      name: 'Olavo Rocha MEI',
      cnpj: '00082798109',
      state_registration: '00082798109',
      user_id: 90891,
      impersonated: false,
      solfacil_plus: {
        discount_rate: 0.07,
        level: 99,
        __typename: 'SolfacilPlusOut',
      },
      __typename: 'PartnerOut',
    },
    coupon: null,
    __typename: 'GetByPartnerIdOut',
  },
});

export const DeliveryTimeGqlMock = (): GetDeliveryTimeQuery => ({
  getDeliveryTime: {
    id: 2,
    name: 'Solar Inove - Itajaí',
    destination: 'SP',
    delivery_time: {
      dc_time: 2,
      capital: {
        min: 5,
        max: 8,
        __typename: 'ShippingTime',
      },
      countryside: {
        min: 8,
        max: 11,
        __typename: 'ShippingTime',
      },
      __typename: 'ShippingDeliveryTime',
    },
    __typename: 'Shipping',
  },
});

export const GetEligibleFinancingGqlMock = (): GetEligibleFinancingQuery => ({
  getEligibleFinancing: {
    __typename: 'GetEligibleFinancingOut',
    total: 20,
    data: [
      {
        id: 33188361,
        project_id: '69866459-d137-446a-83a1-ec0e4e837d38',
        financed_value: 25000.0,
        customer_name: 'JOSE CARLOS RIBEIRO REZENDE BALDOINO',
        document: '00082798109',
        created_at: '2024-07-24T21:07:40.630771',
        formalized_at: null,
        installed_at: null,
        status: 'approved',
        system_power: 1750,
        step: 'simulation',
        is_combo: false,
        flow_provider: 'solfacil',
        person_type: 'PF',
        all_payments_sent: false,
        section_statuses: {
          simulation: 'approved',
        },
        is_expired: false,
      },
      {
        id: 57869286,
        project_id: '276a7731-81db-437b-9d03-b99e5e046793',
        financed_value: 25000.0,
        customer_name: 'JOSE CARLOS RIBEIRO REZENDE BALDOINO',
        document: '00082798109',
        created_at: '2024-07-24T19:59:00.472368',
        formalized_at: null,
        installed_at: null,
        status: 'pending',
        system_power: 1750,
        step: 'formalization',
        is_combo: true,
        flow_provider: 'solfacil',
        person_type: 'PF',
        all_payments_sent: false,
        section_statuses: {
          simulation: 'approved',
        },
        is_expired: false,
      },
      {
        id: 32544471,
        project_id: '11bb21f1-9c52-4fab-924b-77e8d743c196',
        financed_value: 22000.0,
        customer_name: 'JOSE CARLOS RIBEIRO REZENDE BALDOINO',
        document: '00082798109',
        created_at: '2024-07-23T20:11:16.040296',
        formalized_at: null,
        installed_at: null,
        status: 'approved',
        system_power: 1750,
        step: 'simulation',
        is_combo: false,
        flow_provider: 'solfacil',
        person_type: 'PF',
        all_payments_sent: false,
        section_statuses: {
          simulation: 'approved',
        },
        is_expired: false,
      },
    ],
  },
});
